import useJwt from '@core/auth/jwt/useJwt'
import axios from '@/libs/axios'
import jwtConfig from '@/auth/jwt/jwt-config'

const { jwt } = useJwt(axios, jwtConfig)
export default jwt
